export default __webpack_public_path__ + "static/banner_2-be2db7e3cd1f467ff1f75ecc1da67076.webp";